exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scan-tip[data-v-09e5b6df] {\n  color: #888;\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n.result-card[data-v-09e5b6df] {\n  border: 1px solid #b7eb8f;\n}\n.result-card.warn[data-v-09e5b6df] {\n  border-color: #ffe58f;\n}\n.result-card p[data-v-09e5b6df] {\n  margin: 4px 0;\n  font-size: 14px;\n}\n.result-title[data-v-09e5b6df] {\n  font-weight: 600;\n  font-size: 16px;\n}\n.result-card.ok .result-title[data-v-09e5b6df] {\n  color: #52c41a;\n}\n.result-card.warn .result-title[data-v-09e5b6df] {\n  color: #faad14;\n}\n.result-msg[data-v-09e5b6df] {\n  color: #888;\n  font-size: 13px;\n}\n", ""]);

// exports
